import { ROUTE_BASENAME_BETA } from "config";

/** Auth user token key */
export const AUTH_USER_TOKEN_KEY = "ReactAmplify.TokenKey";

export const timeProcessing = 120;

export const EMAIL_CONTACT = "support@easyrice.ai";

export const STATE_INFERENCE = {
  QUEUED: "QUEUED",
  PROCESSING: "PROCESSING",
  FAILED: "FAILED",
  SUCCESS: "SUCCESS",
};

export type DefectRiceLevelType = {
  id: string | number;
  value: string;
  image?: {
    normal?: string;
    highlight?: string;
    color?: string;
  };
  level?: string | number;
}[];

interface IdefectRiceLevel {
  [x: string]: DefectRiceLevelType;
}

export const defectRiceLevel: IdefectRiceLevel = {
  undermilled: [
    {
      id: 1,
      value: "undermilled_level_1",
      image: {
        normal: "/image/UnderMill/JPG/UMlv1_1.jpg",
        highlight: "/image/UnderMill/JPG/UMlv1_2.jpg",
      },
      level: 1,
    },
    {
      id: 2,
      value: "undermilled_level_2",
      image: {
        normal: "/image/UnderMill/JPG/UMlv2_1.jpg",
        highlight: "/image/UnderMill/JPG/UMlv2_2.jpg",
      },
      level: 2,
    },
    {
      id: 3,
      value: "undermilled_level_3",
      image: {
        normal: "/image/UnderMill/JPG/UMlv3_1.jpg",
        highlight: "/image/UnderMill/JPG/UMlv3_2.jpg",
      },
      level: 3,
    },
    {
      id: 4,
      value: "undermilled_level_4",
      image: {
        normal: "/image/UnderMill/JPG/UMlv4_1.jpg",
        highlight: "/image/UnderMill/JPG/UMlv4_2.jpg",
      },
      level: 4,
    },
  ],
  chalky: [
    { id: 0, value: "ข้าวที่มีสีขาวขุ่น" },
    { id: 28, value: "ข้าวที่มีสีขาวขุ่น > 50%" },
    {
      id: 1,
      value: "chalky_level_1",
      image: {
        normal: "/image/Chalky/JPG/lv1_1.jpg",
        highlight: "/image/Chalky/JPG/lv1_2.jpg",
      },
      level: 1,
    },
    {
      id: 2,
      value: "chalky_level_2",
      image: {
        normal: "/image/Chalky/JPG/lv2_1.jpg",
        highlight: "/image/Chalky/JPG/lv2_2.jpg",
      },
      level: 2,
    },
    {
      id: 3,
      value: "chalky_level_3",
      image: {
        normal: "/image/Chalky/JPG/lv3_1.jpg",
        highlight: "/image/Chalky/JPG/lv3_2.jpg",
      },
      level: 3,
    },
    {
      id: 4,
      value: "chalky_level_4",
      image: {
        normal: "/image/Chalky/JPG/lv4_1.jpg",
        highlight: "/image/Chalky/JPG/lv4_2.jpg",
      },
      level: 4,
    },
  ],
  damage: [
    {
      id: 1,
      value: "damaged_level_1",
      image: {
        normal: "/image/Damaged/JPG/DMlv1_1.jpg",
        highlight: "/image/Damaged/JPG/DMlv1_2.jpg",
      },
      level: 1,
    },
    {
      id: 2,
      value: "damaged_level_2",
      image: {
        normal: "/image/Damaged/JPG/DMlv2_1.jpg",
        highlight: "/image/Damaged/JPG/DMlv2_2.jpg",
      },
      level: 2,
    },
    {
      id: 3,
      value: "damaged_level_3",
      image: {
        normal: "/image/Damaged/JPG/DMlv3_1.jpg",
        highlight: "/image/Damaged/JPG/DMlv3_2.jpg",
      },
      level: 3,
    },
    {
      id: 4,
      value: "damaged_level_4",
      image: {
        normal: "/image/Damaged/JPG/DMlv4_1.jpg",
        highlight: "/image/Damaged/JPG/DMlv4_2.jpg",
      },
      level: 4,
    },
  ],
  yellow: [
    {
      id: 1,
      value: "yellow_level_1",
      image: {
        normal: "/image/Yellow/Y01.png",
        highlight: null,
        color: "#F4F1F2",
      },
      level: 1,
    },
    {
      id: 2,
      value: "yellow_level_2",
      image: {
        normal: "/image/Yellow/Y02.png",
        highlight: null,
        color: "#E2DEDB",
      },
      level: 2,
    },
    {
      id: 3,
      value: "yellow_level_3",
      image: {
        normal: "/image/Yellow/Y03.png",
        highlight: null,
        color: "#E0D7D1",
      },
      level: 3,
    },
    {
      id: 4,
      value: "yellow_level_4",
      image: {
        normal: "/image/Yellow/Y04.png",
        highlight: null,
        color: "#E5D9CB",
      },
      level: 4,
    },
    {
      id: 5,
      value: "yellow_level_5",
      image: {
        normal: "/image/Yellow/Y05.png",
        highlight: null,
        color: "#DCD1C3",
      },
      level: 5,
    },
    {
      id: 6,
      value: "yellow_level_6",
      image: {
        normal: "/image/Yellow/Y06.png",
        highlight: null,
        color: "#D9C1AA",
      },
      level: 6,
    },
    {
      id: 7,
      value: "yellow_level_7",
      image: {
        normal: "/image/Yellow/Y07.png",
        highlight: null,
        color: "#D9C199",
      },
      level: 7,
    },
    {
      id: 8,
      value: "yellow_level_8",
      image: {
        normal: "/image/Yellow/Y08.png",
        highlight: null,
        color: "#D8BD95",
      },
      level: 8,
    },
    {
      id: 9,
      value: "yellow_level_9",
      image: {
        normal: "/image/Yellow/Y09.png",
        highlight: null,
        color: "#C7A984",
      },
      level: 9,
    },
    {
      id: 10,
      value: "yellow_level_10",
      image: {
        normal: "/image/Yellow/Y10.png",
        highlight: null,
        color: "#CD9E79",
      },
      level: 10,
    },
  ],
  colorChalky: [
    { id: 0, value: "ข้าวที่มีสีขาวขุ่น" },
    { id: 28, value: "ข้าวที่มีสีขาวขุ่น > 50%" },
  ],
  head: [
    {
      id: 7,
      value: "wholeGrain_level_1",
      image: {
        normal: "/image/Head/H01.png",
        highlight: null,
      },
      level: 1,
    },
    {
      id: 8,
      value: "wholeGrain_level_2",
      image: {
        normal: "/image/Head/H02.png",
        highlight: null,
      },
      level: 2,
    },
    {
      id: 9,
      value: "wholeGrain_level_3",
      image: {
        normal: "/image/Head/H03.png",
        highlight: null,
      },
      level: 3,
    },
    {
      id: 10,
      value: "wholeGrain_level_4",
      image: {
        normal: "/image/Head/H04.png",
        highlight: null,
      },
      level: 4,
    },
  ],
};

export const TELE_NUMBER = "082-042-9650";
export const TELE_NUMBER_VI = "090-486-0346";
export const MESSAGE_IN_QUEQ = "THIS_USER_IN_QUEUE";

export const COLOR_RICE_RESULT_TYPE = {
  type_color_1: [
    { name: "ข้าวขาว", color: "#FFFFFF" },
    { name: "yellow", color: "#FFF500" },
    { name: "ข้าวเปลือก", color: "#14FF00" },
    { name: "chalky", color: "#00FFFF" },
    { name: "ข้าวเหนียว", color: "#0085FF" },
    {
      name: "undermilled_full",
      color: "#FF0000",
    },
    { name: "damage", color: "#AD00FF" },
  ],
  type_color_2: [
    { name: "ข้าวกล้อง", color: "#FF9800" },
    { name: "undermilled_full", color: "#FF0000" },
    { name: "ข้าวท้องไข่และข้าวเหนียว", color: "#00FFFF" },
    { name: "damage", color: "#AD00FF" },
    { name: "เมล็ดอ่อน", color: "#A2FF86" },
    { name: "ข้าวเปลือก", color: "#14FF00" },
  ],
};
export const COLOR_RICE_RESULT_SHAPE = {
  shape_color_1: [
    { name: "wholeGrain", color: "#02C02F" },
    { name: "ต้นข้าวและข้าวหัก", color: "#FFFFFF" },
  ],
  shape_color_2: [
    { name: "wholeGrain", color: "#02C02F" },
    { name: "ต้นข้าว", color: "#FFFFFF" },
    { name: "ข้าวหัก", color: "#FDA4BA" },
  ],
};

export const DEFAULT_COLOR_DESCRIPTION_RICE_RESULT = {
  shape: "shape_color_1",
  type: "type_color_1",
};

export const MANUAL_PATH_LIST = {
  th: "https://easyrice-1.gitbook.io/easy-rice-m0/",
  en: "https://easyrice-product-manual.s3.ap-southeast-1.amazonaws.com/M0-Manual-V2.2.0-ENG.pdf",
};

export const MANUAL_PATH_BY_FEATURE = {
  level: {
    yellow: {
      th: "https://easyrice-1.gitbook.io/easy-rice-m0/inspection-setting/defect-rice-setting/yellow",
      en: "https://easyrice-product-manual.s3.ap-southeast-1.amazonaws.com/M0-Manual-V2.2.0-ENG.pdf",
    },
    chalky: {
      th: "https://easyrice-1.gitbook.io/easy-rice-m0/inspection-setting/defect-rice-setting/chalky",
      en: "https://easyrice-product-manual.s3.ap-southeast-1.amazonaws.com/M0-Manual-V2.2.0-ENG.pdf",
    },
    damaged: {
      th: "https://easyrice-1.gitbook.io/easy-rice-m0/inspection-setting/defect-rice-setting/damaged",
      en: "https://easyrice-product-manual.s3.ap-southeast-1.amazonaws.com/M0-Manual-V2.2.0-ENG.pdf",
    },
    undermilled: {
      th: "https://easyrice-1.gitbook.io/easy-rice-m0/inspection-setting/defect-rice-setting/undermilled",
      en: "https://easyrice-product-manual.s3.ap-southeast-1.amazonaws.com/M0-Manual-V2.2.0-ENG.pdf",
    },
    head: {
      th: "https://easyrice-1.gitbook.io/easy-rice-m0/inspection-setting/composition-setting/whole-grain",
      en: "https://easyrice-product-manual.s3.ap-southeast-1.amazonaws.com/M0-Manual-V2.2.0-ENG.pdf",
    },
  },
};

export const BETA_PATH_TUTORIAL = "/tutorial-beta";
export const BETA_PATH = ROUTE_BASENAME_BETA;

export const ERROR_STATE = {
  IMAGE_ERROR: "image_p1",
  LIMIT_REACHED: "limitReached",
};

export const NO_LIMIT_OF_USAGE = -1;
export const WARNING_BEFORE_LIMIT_OF_USAGE_LV_1 = 100;
export const WARNING_BEFORE_LIMIT_OF_USAGE_LV_2 = 50;
